import React from 'react';
import styles from './Error.module.scss';
import { Container } from '@/components/ui/Container/Container';
import GradientText from '@/components/ui/GradientText/GradientText';
import CTAButton from '@/components/ui/buttons/CTAButton/CTAButton';
import { Dictionary } from '@/content/i18n/schema';
import { Section } from '@/components/ui/Section/Section';

interface ErrorSectionProps {
  dict: Dictionary['error'];
  reset?: () => void;
}

export default function ErrorSection({ dict, reset }: ErrorSectionProps) {
  return (
    <Section className={styles.error}>
      <Container>
        <div className={styles.content}>
          <GradientText as="h1" className={styles.title}>
            {dict.title}
          </GradientText>
          <h2>{dict.subtitle}</h2>
          <p>{dict.description}</p>
          <div>
            <CTAButton
              mode="button"
              onClick={() => reset?.() ?? window.location.reload()}
              variant="orange"
            >
              {dict.button}
            </CTAButton>
          </div>
        </div>
      </Container>
    </Section>
  );
}
